export default __webpack_public_path__ + "static/media/5-Pre-Listing-offices.6b50656b.png";